import BaseClient from '@/app/model/api/response/baseApiClient'

class RiskListApi extends BaseClient {
  public getRiskList (data: any) {
    const path = '/v1/master/risks'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    if (data.word !== '') {
      params.append('word', data.word)
    }
    if (data.order_name !== '') {
      params.append('order_name', data.order_name)
    }
    if (data.sort === false) {
      params.append('sort', 'desc')
    } else {
      params.append('sort', 'asc')
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new RiskListApi()
